var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreaterThanEqual(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.805 326.686C41.008 342.406 56.068 352 72.021 352C76.896 352 81.865 351.094 86.693 349.219L390.688 229.213C405.969 223.182 416 208.432 416 191.992C416 175.555 405.969 160.805 390.688 154.771L86.693 34.768C66.068 26.736 42.883 36.768 34.805 57.299C26.695 77.863 36.773 101.082 57.318 109.209L267.064 191.992L57.318 274.777C36.773 282.902 26.695 306.123 34.805 326.686ZM408.016 400H39.984C17.902 400 0 417.908 0 440S17.902 480 39.984 480H408.016C430.098 480 448 462.092 448 440V439.998C448 417.908 430.098 400 408.016 400Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreaterThanEqual);
export default __webpack_public_path__ + "static/media/greater-than-equal.0fcdba0424d1b10c5bcd014597099bfc.svg";
export { ForwardRef as ReactComponent };